module.exports = __webpack_public_path__ + "static/img/AL.e1084652.png";